export const SELECTION_CHIPS_CONFIG = {
  MAX_VISIBLE_CHIPS: 4,
  ITEM_HEIGHT: 40,
  VISIBLE_ITEMS: 8,
  BUFFER_SIZE: 20,
  ANIMATION_DURATION: 150,
} as const;

export const SCROLL_AREA_CONFIG = {
  VERTICAL_WIDTH: "w-2.5",
  HORIZONTAL_HEIGHT: "h-2.5",
} as const;

export const CACHE_CONFIG = {
  MAX_CACHE_SIZE: 50,
  CLEANUP_THRESHOLD: 25,
} as const;
